// Role constants for role-based access control
export const ROLES = {
  ADMIN: 'Admin',
  EMPLOYER: 'User'
};

// Helper function to check if user has required role
export const hasRole = (userRole, allowedRoles) => {
  return allowedRoles.includes(userRole);
};

// Common role combinations
export const ADMIN_ONLY = [ROLES.ADMIN];
export const EMPLOYER_ONLY = [ROLES.EMPLOYER];
export const ALL_ROLES = [ROLES.ADMIN, ROLES.EMPLOYER];
